import { render, staticRenderFns } from "./PromoDelete.vue?vue&type=template&id=9611eeae"
import script from "./PromoDelete.vue?vue&type=script&lang=js"
export * from "./PromoDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports